import { useHistory, useParams } from "react-router-dom";
import * as L from "leaflet";

import { useCase } from "src/hooks/useCase";
import { Pane } from "src/components/Pane";
import { PoiCreatePage } from "./PoiCreatePage";
import { PoiEditPage } from "./PoiEditPage";

interface Props {
  map: L.Map;
}

export function PoiPage(props: Props) {
  const history = useHistory();
  const params = useParams<{ caseId: string; poiId: string }>();
  const { data: acase } = useCase(params.caseId);

  function handleClose() {
    if (!acase) return null;
    history.push(`/cases/${acase.id}/pois`);
  }

  return render();

  function render() {
    if (params.poiId === "new") {
      return (
        <Pane>
          <PoiCreatePage onClose={handleClose} {...props} />
        </Pane>
      );
    }
    // else
    return (
      <Pane>
        <PoiEditPage key={`${params.caseId}-${params.poiId}`} onClose={handleClose} {...props} />
      </Pane>
    );
  }
}
